// checks if given argument is a valid relative path (should start with a slash).
// External links will return false.
export default function isValidRelativePath(path: unknown): path is string {
  if (typeof path === "string") {
    return Boolean(/^\/\w.*/.exec(path));
  }
  return false;
}
